export default function convertTextToTitleCase(text) {
  // This method converts text to title case and ignores punctuation
  if (text === '' || text === null) {
    return '';
  }

  return text.toLowerCase().replace(new RegExp('(?:\\b|_)([a-z])', 'g'), ($1) => $1.toUpperCase());
}
